<template>
  <div>
    <div class="d-flex flex-wrap">
      <div>
        <h2>
          <slot>
            <FlexTextIcon
              v-if="icon"
              :icon="icon">
              {{ $t(title, props) }}
            </FlexTextIcon>
            <span v-else>{{ $t(title, props) }}</span>
          </slot>
        </h2>
      </div>
      <div class="ms-auto mb-2">
        <slot name="end"/>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import FlexTextIcon from '@components/FlexTextIcon.vue';
import {defineComponent} from 'vue';

export default defineComponent({
  components: {
    FlexTextIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: [Array, String],
    },
    props: Object,
  },
});
</script>
